<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex md12>
        <v-card title>
          <v-card-title>
            <h2>Correos Simulador General</h2>
          </v-card-title>
          <v-card-text>
            <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction" />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <MainFormDialog v-if="get_dialogMain.dialog" :fields="form" :model="main" :urls="urls" :message="message"/>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import MainFormDialog from '@/components/dialogs/MainFormDialog'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'precalificacion.correos.store' }
        ],
        titles: [
          { text: 'Correo', value: 'contacto', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Fecha Actualizada', value: 'Updated', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        losading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-border-color', color: 'yellow darken-2', action: 'toEditData', code: 'precalificacion.correos.update' },
          { title: 'Eliminar', icon: 'mdi-delete', color: 'red darken-2', action: 'DeleteData', code: 'precalificacion.correos.delete' }
        ]
      },
      footer: {
        paging: true
      }
    },
    main: {},
    form: [],
    urls: '',
    message: '',
    id: 0
  }),
  components: {
    DataTableMain,
    MainFormDialog
  },
  mounted () {
    const user = this.$cookies.get('user')
    this.id = user.id
    this.PostListObjects({ url: '/contactos', data: { folio: 'SIMULADOR_GRAL' } })
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['PostListObjects', 'DeleteObject']),
    ...mapMutations(['SHOW_DIALOG_MAIN']),
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.PostListObjects({ url: '/contactos', data: { folio: 'SIMULADOR_GRAL' } })
    },
    newData (item) {
      this.main = {}
      this.form = this.get_CorreosdForm
      this.urls = '/contactos/store'
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Nuevo Cliente' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    toEditData ({ item }) {
      this.main = item
      this.form = this.get_CorreosdForm
      this.urls = `/contactos/${item.id}`
      this.message = 'Registro Actualizado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'update', with: 850, title: 'Nuevo Cliente' })
    },
    DeleteData ({ item }) {
      this.$swal.fire({
        title: 'Estas seguro de eliminar el registro?',
        text: 'No podras revertir este movimiento!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar!'
      }).then((result) => {
        if (result.value) {
          this.table.header.loading = true
          this.DeleteObject({ url: `/contactos/${item.id}` })
        }
      })
    },
    DeleteConfirmData ({ item }) {
      this.$swal.fire({
        title: 'Estas seguro de eliminar el registro definitivamente?',
        text: 'No podras revertir este movimiento!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar!'
      }).then((result) => {
        if (result.value) {
          this.table.header.loading = true
          this.DeleteObject({ url: `/clientes/delete/confirm/${item.id}` })
        }
      })
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_objects', 'get_CorreosdForm'])
  },
  watch: {
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.modelMain = []
        if (vals.length > 0) {
          this.table.modelMain.push(vals[0])
        }
        this.table.body.data = vals
      }
    }
  }
}
</script>

<style></style>
